<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <section style="padding:20px;">
    <!--工具条-->
    <el-col :span="24" class="toolbar not-print" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-col>
          <el-form-item label="客户名称:" v-if="me.rname === 'ROLE_PLATFORM' || me.rname === 'ROLE_ADMIN' || me.rname === 'ROLE_DEMO'">
            <el-select v-model="filters.companyId" filterable clearable placeholder="请选择" @change="companyChange">
              <el-option
                v-for="item in companies" :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域:">
            <el-select v-model="filters.groupId" clearable placeholder="请选择" @change="groupChange">
              <el-option
                v-for="item in groups" :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称:" >
            <el-select v-model="filters.deviceId" clearable placeholder="请选择" @change="deviceChange">
              <el-option
                      v-for="item in devices"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参数名称:" >
            <el-select v-model="filters.dataType" clearable placeholder="请选择">
              <el-option
                      v-for="item in deviceAlias"
                      :key="item.id"
                      :label="item.channelAlias"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="时间范围:" >
            <el-date-picker
                    v-model="filters.timeRange"
                    type="datetimerange"
                    :picker-options="pickerOptions2"
                    placeholder="选择时间范围"
                    align="right">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="handleCurrentChange(1)" size="small">查询</el-button>
          </el-form-item>
          <!--<el-form-item>-->
            <!--<el-button type="primary" @click="" size="small">导出</el-button>-->
          <!--</el-form-item>-->
          <el-form-item>
            <el-button type="primary" @click="print" size="small">打印</el-button>
          </el-form-item>
          <el-form-item v-if="filters.deviceId && filters.dataType >= 5 && filters.dataType <= 15">
            <el-button type="primary" @click="viewChart" size="small">查看曲线</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="hisData" border highlight-current-row v-loading="listLoading"
              style="width: 100%;" class="not-print">
      <el-table-column
              header-align="center"
              align="center"
              type="index"
              width="60">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="companyName" label="客户名称">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="groupName" label="区域">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="deviceName" label="设备名称">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="des" label="参数名称">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="参数值">
        <template scope="scope">
          <span v-if="scope.row.type >= 53 && scope.row.type <= 55 && scope.row.value == 0">-</span>
          <span v-if="!((scope.row.type >= 53 && scope.row.type <= 55) && scope.row.value == 0)">{{scope.row.value}}{{scope.row.unit}}</span>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="createdAt" label="采集时间" :formatter="formatDate"
                       >
      </el-table-column>
    </el-table>

    <el-table :data="hisData" border highlight-current-row v-loading="listLoading"
              style="width: 100%;display: none;" class="print">
      <el-table-column
              header-align="center"
              align="center"
              type="index"
              width="60">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="companyName" label="客户名称" width="160">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="groupName" label="区域" width="160">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="deviceName" label="设备名称" width="160">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="des" label="参数名称" width="160">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="参数值" width="125">
        <template scope="scope">
          {{scope.row.value}}{{scope.row.unit}}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="createdAt" label="采集时间" :formatter="formatDate" width="180">
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="20" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog v-model="chartVisible" size="large" :close-on-click-modal="true" style="height: 600px;">
      <div id="chart" class="chart2"></div>
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  import echarts from 'echarts'
  //import NProgress from 'nprogress'
  import {getDataList,getChartDataList,getCompanyList,getGroupList,getDevicesByGroupList,getDeviceAliasList} from '../../api/api';

  import moment from 'moment';

  export default {
    data() {
      return {
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        me: JSON.parse(sessionStorage.getItem('user')),
        hisData: [],
        companies: [],
        deviceAlias: [],
        groups: [],
        devices: [],
        listLoading: false,
        chartVisible: false,
        page: 0,
        currentPage: 1,
        total: 0,
        chart: {},
        filters: {
          companyId: '',
          groupId: '',
          deviceId: '',
          dataType: '',
          timeRange: [moment().hours(0).minutes(0).seconds(0).toDate(), moment().hours(0).minutes(0).seconds(0).add(1, 'days').toDate()]
        },
        names: [
          {name: 'A相正向有功电能', type: 1},
          {name: 'B相正向有功电能', type: 2},
          {name: 'C相正向有功电能', type: 3},
          {name: '总正向有功电能', type: 4},
          {name: '第1路温度', type: 5},
          {name: '第2路温度', type: 6},
          {name: '第3路温度', type: 7},
          {name: '第4路温度', type: 8},
          {name: 'A相电压', type: 9},
          {name: 'B相电压', type: 10},
          {name: 'C相电压', type: 11},
          {name: 'A相电流', type: 12},
          {name: 'B相电流', type: 13},
          {name: 'C相电流', type: 14},
          {name: '零线电流', type: 15},
          {name: 'A相有功功率', type: 16},
          {name: 'B相有功功率', type: 17},
          {name: 'C相有功功率', type: 18},
          {name: '总有功功率', type: 19},
          {name: 'A相功率因素', type: 20},
          {name: 'B相功率因素', type: 21},
          {name: 'C相功率因素', type: 22},
          {name: '总功率因素', type: 23},
          {name: '电压不平衡度', type: 24},
          {name: '电流不平衡度', type: 25},
          {name: 'A相无功功率', type: 26},
          {name: 'B相无功功率', type: 27},
          {name: 'C相无功功率', type: 28},
          {name: '总无功功率', type: 29},
          {name: '频率', type: 30},
          {name: 'A相3次谐波电流', type: 35},
          {name: 'B相3次谐波电流', type: 36},
          {name: 'C相3次谐波电流', type: 37},
          {name: 'A相电压3次谐波含量', type: 38},
          {name: 'B相电压3次谐波含量', type: 39},
          {name: 'C相电压3次谐波含量', type: 40},
          {name: 'A相电压5次谐波含量', type: 41},
          {name: 'B相电压5次谐波含量', type: 42},
          {name: 'C相电压5次谐波含量', type: 43},
          {name: 'A相电压7次谐波含量', type: 44},
          {name: 'B相电压7次谐波含量', type: 45},
          {name: 'C相电压7次谐波含量', type: 46},
          {name: 'A相电压9次谐波含量', type: 47},
          {name: 'B相电压9次谐波含量', type: 48},
          {name: 'C相电压9次谐波含量', type: 49},
          {name: 'A相电压11次谐波含量', type: 50},
          {name: 'B相电压11次谐波含量', type: 51},
          {name: 'C相电压11次谐波含量', type: 52},
          {name: 'A相电压合格率', type: 53},
          {name: 'B相电压合格率', type: 54},
          {name: 'C相电压合格率', type: 55},
          {name: 'A相电压波形失真度', type: 56},
          {name: 'B相电压波形失真度', type: 57},
          {name: 'C相电压波形失真度', type: 58},
          {name: 'A相电流波形失真度', type: 59},
          {name: 'B相电流波形失真度', type: 60},
          {name: 'C相电流波形失真度', type: 61},
          {name: '剩余电流', type: 63},
        ]
      }
    },
    filters: {

    },
    methods: {
      formatDate: function (row, column) {
        return moment(row.createdAt).utc().format('YYYY-MM-DD HH:mm:ss');
      },
      handleCurrentChange(val) {
        this.page = val - 1;
        this.currentPage = this.page + 1;
        this.getDatas();
      },
      //获取企业列表
      getCompanies() {
        let para = {
          name: ''
        };
        //NProgress.start();
        getCompanyList(para).then((res) => {
          this.companies = res.data.list;
          //NProgress.done();
        });
      },
      //获取企业列表
      getGroups(company) {
        let para = {
          companyId: company
        };
        //NProgress.start();
        getGroupList(para).then((res) => {
          this.groups = res.data.list;
          if (this.groups.length == 0) {
            if (this.filters.companyId)
              this.getDevicesByGroup('');
          } else {
            this.getDevicesByGroup(this.groups[0].id);
          }
          //NProgress.done();
        });
      },
      getChannelAlias(deviceId) {
        let para = {
          deviceId: deviceId
        };
        //NProgress.start();
        getDeviceAliasList(para).then((res) => {
          this.deviceAlias = res.data;
          //NProgress.done();
        });
      },
      getDevicesByGroup(val) {
        let para = {
          groupId: val
        };
        //NProgress.start();
        getDevicesByGroupList(para).then((res) => {
          this.devices = res.data;
          //NProgress.done();
        });
      },
      companyChange: function (val) {
        this.filters.groupId = '';
        this.filters.deviceId = '';
        this.getGroups(val);
      },
      groupChange: function (val) {
        this.filters.deviceId = '';
        this.getDevicesByGroup(val);
      },
      getDatas() {
        if (!this.filters.timeRange) {
          this.filters.timeRange = [moment().hours(0).minutes(0).seconds(0).toDate(), moment().hours(0).minutes(0).seconds(0).add(1, 'days').toDate()];
        }
        let para = {
          page: this.page,
          size: 20,
          companyId: this.filters.companyId,
          groupId: this.filters.groupId,
          deviceId: this.filters.deviceId,
          type: this.filters.dataType,
          timeRangeStart: moment.utc(this.filters.timeRange[0]).valueOf(),
          timeRangeEnd: moment.utc(this.filters.timeRange[1]).valueOf(),
        };
        this.listLoading = true;
        //NProgress.start();
        getDataList(para).then((res) => {
          this.total = res.data.total;
          this.hisData = res.data.data;
          this.listLoading = false;
          //NProgress.done();
        });
      },
      print() {
        window.print();
      },
      viewChart() {
        this.chartVisible = true;
        if (!this.filters.timeRange) {
          this.filters.timeRange = [moment().hours(0).minutes(0).seconds(0).toDate(), moment().hours(0).minutes(0).seconds(0).add(1, 'days').toDate()];
        }
        let para = {
          deviceId: this.filters.deviceId,
          type: '5,6,7,8,9,10,11,12,13,14,15',
          timeRangeStart: moment.utc(this.filters.timeRange[0]).valueOf(),
          timeRangeEnd: moment.utc(this.filters.timeRange[1]).valueOf(),
        };
        setTimeout(t => {
          this.chart = echarts.init(document.getElementById('chart'));
          this.chart.showLoading();
        }, 100);
        //NProgress.start();
        getChartDataList(para).then((res) => {
          var data = res.data;
          var options = {
            title: {
              text: '历史数据曲线',
              subtext: moment(this.filters.timeRange[0]).format('YYYY/MM/DD') + '-' + moment(this.filters.timeRange[1]).format('YYYY/MM/DD'),
              top: 0,
              left: 'center',
              textStyle: {
                fontSize: 14,
                color: '#666666'
              }
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              top: '15%',
              right: '3%',
              orient: 'vertical',
              data: ['第1路温度(℃)', '第2路温度(℃)', '第3路温度(℃)', '第4路温度(℃)', 'A相电压(V)', 'B相电压(V)', 'C相电压(V)', 'A相电流(A)', 'B相电流(A)', 'C相电流(A)', '零线电流(A)']
            },
            grid: {
              left: '3%',
              right: '17%',
              top: '18%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
            },
            yAxis: {
              type: 'value'
            },
            series: []
          };

          var value1 = data.map(el => {
            if (el.des == "第1路温度")
              return el;
          }).filter(t => {return t});

          var value2 = data.map(el => {
            if (el.des == "第2路温度")
              return el;
          }).filter(t => {return t});

          var value3 = data.map(el => {
            if (el.des == "第3路温度")
              return el;
          }).filter(t => {return t});

          var value4 = data.map(el => {
            if (el.des == "第4路温度")
              return el;
          }).filter(t => {return t});

          var valueV1 = data.map(el => {
            if (el.des == "A相电压")
              return el;
          }).filter(t => {return t});

          var valueV2 = data.map(el => {
            if (el.des == "B相电压")
              return el;
          }).filter(t => {return t});

          var valueV3 = data.map(el => {
            if (el.des == "C相电压")
              return el;
          }).filter(t => {return t});

          var valueA = data.map(el => {
            if (el.des == "A相电流")
              return el;
          }).filter(t => {return t});

          var valueB = data.map(el => {
            if (el.des == "B相电流")
              return el;
          }).filter(t => {return t});

          var valueC = data.map(el => {
            if (el.des == "C相电流")
              return el;
          }).filter(t => {return t});

          var value0 = data.map(el => {
            if (el.des == "零线电流")
              return el;
          }).filter(t => {return t});

          var time = valueA.map(t => {return moment.utc(t.createdAt).format('HH:mm:ss')}).reverse();
          var serA = {
            name: 'A相电流(A)',
            type: 'line',
            smooth:true,
            data: valueA.map(t => {return t.value}).reverse()
          };
          var serB = {
            name: 'B相电流(A)',
            type: 'line',
            smooth:true,
            data: valueB.map(t => {return t.value}).reverse()
          };
          var serC = {
            name: 'C相电流(A)',
            type: 'line',
            smooth:true,
            data: valueC.map(t => {return t.value}).reverse()
          };
          var ser0 = {
            name: '零线电流(A)',
            type: 'line',
            smooth:true,
            data: value0.map(t => {return t.value}).reverse()
          };
          var ser1 = {
            name: '第1路温度(℃)',
            type: 'line',
            smooth:true,
            data: value1.map(t => {return t.value}).reverse()
          };
          var ser2 = {
            name: '第2路温度(℃)',
            type: 'line',
            smooth:true,
            data: value2.map(t => {return t.value}).reverse()
          };
          var ser3 = {
            name: '第3路温度(℃)',
            type: 'line',
            smooth:true,
            data: value3.map(t => {return t.value}).reverse()
          };
          var ser4 = {
            name: '第4路温度(℃)',
            type: 'line',
            smooth:true,
            data: value4.map(t => {return t.value}).reverse()
          };
          var serV1 = {
            name: 'A相电压(V)',
            type: 'line',
            smooth:true,
            data: valueV1.map(t => {return t.value}).reverse()
          };
          var serV2 = {
            name: 'B相电压(V)',
            type: 'line',
            smooth:true,
            data: valueV2.map(t => {return t.value}).reverse()
          };
          var serV3 = {
            name: 'C相电压(V)',
            type: 'line',
            smooth:true,
            data: valueV3.map(t => {return t.value}).reverse()
          };
          options.series = [serA, serB, serC, ser0, ser1, ser2, ser3, ser4, serV1, serV2, serV3];
          options.xAxis.data = time;
          this.chart.setOption(options);
          this.chart.hideLoading();
          this.chart.on('legendselectchanged', function (params) {
            if (params.name == 'A相电流')
              time = valueA.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == 'B相电流')
              time = valueB.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == 'C相电流')
              time = valueC.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == '零线电流')
              time = value0.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == '第1路温度')
              time = value1.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == '第2路温度')
              time = value2.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == '第3路温度')
              time = value3.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == '第4路温度')
              time = value4.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == 'A相电压')
              time = valueV1.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == 'B相电压')
              time = valueV2.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            else if (params.name == 'C相电压')
              time = valueV3.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
          });
          //NProgress.done();
          var a = this.names.filter(t => t.type == this.filters.dataType);
          var selectName = '第1路温度(℃)';
          switch(this.filters.dataType) {
            case 12:
            case 13:
            case 14:
            case 15:
              selectName = a[0].name + '(A)';
              break;
            case 5:
            case 6:
            case 7:
            case 8:
              selectName = a[0].name + '(℃)';
              break;
            case 9:
            case 10:
            case 11:
              selectName = a[0].name + '(V)';
              break;
          }


          this.chart.dispatchAction({
            type: 'legendSelect',
            // 图例名称
            name: selectName
          })
        });
      },
      deviceChange: function (val) {
        if (!!val) {
          var selectedDeviceId = this.devices.filter(t => t.id == val)[0].deviceId;
          this.filters.dataType = '';
          if (selectedDeviceId.toUpperCase().startsWith("9")) {
            this.getChannelAlias(selectedDeviceId);
//            this.names = [
//              {name: '第1路剩余电流', type: 101},
//              {name: '第2路剩余电流', type: 102},
//              {name: '第3路剩余电流', type: 103},
//              {name: '第4路剩余电流', type: 104},
//              {name: '第5路剩余电流', type: 105},
//              {name: '第6路剩余电流', type: 106},
//              {name: '第7路剩余电流', type: 107},
//              {name: '第8路剩余电流', type: 108},
//              {name: '第1路温度', type: 201},
//              {name: '第2路温度', type: 202},
//              {name: '第3路温度', type: 203},
//              {name: '第4路温度', type: 204},
//              {name: '第5路温度', type: 205},
//              {name: '第6路温度', type: 206},
//              {name: '第7路温度', type: 207},
//              {name: '第8路温度', type: 208}
//            ]
          } else {
            this.deviceAlias = [
              {channelAlias: 'A相正向有功电能', id: 1},
              {channelAlias: 'B相正向有功电能', id: 2},
              {channelAlias: 'C相正向有功电能', id: 3},
              {channelAlias: '总正向有功电能', id: 4},
              {channelAlias: '第1路温度', id: 5},
              {channelAlias: '第2路温度', id: 6},
              {channelAlias: '第3路温度', id: 7},
              {channelAlias: '第4路温度', id: 8},
              {channelAlias: 'A相电压', id: 9},
              {channelAlias: 'B相电压', id: 10},
              {channelAlias: 'C相电压', id: 11},
              {channelAlias: 'A相电流', id: 12},
              {channelAlias: 'B相电流', id: 13},
              {channelAlias: 'C相电流', id: 14},
              {channelAlias: '零线电流', id: 15},
              {channelAlias: 'A相有功功率', id: 16},
              {channelAlias: 'B相有功功率', id: 17},
              {channelAlias: 'C相有功功率', id: 18},
              {channelAlias: '总有功功率', id: 19},
              {channelAlias: 'A相功率因素', id: 20},
              {channelAlias: 'B相功率因素', id: 21},
              {channelAlias: 'C相功率因素', id: 22},
              {channelAlias: '总功率因素', id: 23},
              {channelAlias: '电压不平衡度', id: 24},
              {channelAlias: '电流不平衡度', id: 25},
              {channelAlias: 'A相无功功率', id: 26},
              {channelAlias: 'B相无功功率', id: 27},
              {channelAlias: 'C相无功功率', id: 28},
              {channelAlias: '总无功功率', id: 29},
              {channelAlias: '频率', id: 30},
              {channelAlias: 'A相3次谐波电流', id: 35},
              {channelAlias: 'B相3次谐波电流', id: 36},
              {channelAlias: 'C相3次谐波电流', id: 37},
              {channelAlias: 'A相电压3次谐波含量', id: 38},
              {channelAlias: 'B相电压3次谐波含量', id: 39},
              {channelAlias: 'C相电压3次谐波含量', id: 40},
              {channelAlias: 'A相电压5次谐波含量', id: 41},
              {channelAlias: 'B相电压5次谐波含量', id: 42},
              {channelAlias: 'C相电压5次谐波含量', id: 43},
              {channelAlias: 'A相电压7次谐波含量', id: 44},
              {channelAlias: 'B相电压7次谐波含量', id: 45},
              {channelAlias: 'C相电压7次谐波含量', id: 46},
              {channelAlias: 'A相电压9次谐波含量', id: 47},
              {channelAlias: 'B相电压9次谐波含量', id: 48},
              {channelAlias: 'C相电压9次谐波含量', id: 49},
              {channelAlias: 'A相电压11次谐波含量', id: 50},
              {channelAlias: 'B相电压11次谐波含量', id: 51},
              {channelAlias: 'C相电压11次谐波含量', id: 52},
              {channelAlias: 'A相电压合格率', id: 53},
              {channelAlias: 'B相电压合格率', id: 54},
              {channelAlias: 'C相电压合格率', id: 55},
              {channelAlias: 'A相电压波形失真度', id: 56},
              {channelAlias: 'B相电压波形失真度', id: 57},
              {channelAlias: 'C相电压波形失真度', id: 58},
              {channelAlias: 'A相电流波形失真度', id: 59},
              {channelAlias: 'B相电流波形失真度', id: 60},
              {channelAlias: 'C相电流波形失真度', id: 61},
              {channelAlias: '剩余电流', id: 63},
            ]
          }
        } else {
          this.filters.dataType = '';
          this.names = [];
        }

      }
    },
    mounted() {
      this.filters.companyId = (this.me.rname === 'ROLE_PLATFORM' || this.me.rname === 'ROLE_ADMIN') ? '' : this.me.companyId;
      this.getDatas();
      this.getCompanies();
      this.getGroups(this.filters.companyId);
    },
    components: {

    },
  }

</script>

<style>
  @media print {
    .not-print {
      display: none;
    }
    .print {
      display: block !important;
    }
  }
  .chart2 {
    width: 100% !important;
    height: 400px !important;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// His.vue?6b53f430